var asciiToArray = require("./_asciiToArray"), hasUnicode = require("./_hasUnicode"), unicodeToArray = require("./_unicodeToArray");
function stringToArray(string) {
  return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
}
module.exports = stringToArray;
